/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SiteUpdate
 */
export interface SiteUpdate {
    /**
     * 
     * @type {string}
     * @memberof SiteUpdate
     */
    label?: string | null;
}

/**
 * Check if a given object implements the SiteUpdate interface.
 */
export function instanceOfSiteUpdate(value: object): value is SiteUpdate {
    return true;
}

export function SiteUpdateFromJSON(json: any): SiteUpdate {
    return SiteUpdateFromJSONTyped(json, false);
}

export function SiteUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): SiteUpdate {
    if (json == null) {
        return json;
    }
    return {
        
        'label': json['label'] == null ? undefined : json['label'],
    };
}

export function SiteUpdateToJSON(json: any): SiteUpdate {
    return SiteUpdateToJSONTyped(json, false);
}

export function SiteUpdateToJSONTyped(value?: SiteUpdate | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'label': value['label'],
    };
}

